
angular.module('tf.directives')

    .directive('chartDatePicker', function() {
    return {
        restrict: 'E',
        templateUrl: "js/components/charts/chartDatePicker/chartDatePicker.html",
        replace: true,
        scope : {
            fromDate: "=?",
            toDate  : "=?"
        },
        link : function(scope, element){


        }

    };
});